import { useGetInTouchContext } from '@components/get-in-touch/Context';
import { Button } from '@components/ui/Button';
import SmallContainer from '@components/ui/layout/SmallContainer';
import { Heading } from '@components/ui/typography';
import { spacingBottomM } from '@components/_blog-detail/spacings';
import { parse } from '@config/theme';
import { cx } from '@linaria/core';
import React, { FC } from 'react';
import { CbCta as CbCtaModel } from '__generated__/sanity';
export const CbCta: FC<CbCtaModel> = ({
  text
}) => {
  const {
    setIsVisible
  } = useGetInTouchContext();
  return <SmallContainer className={cx(container, spacingBottomM)}>
      <Heading as="div" variant="h3" mb={{
      _: '8',
      sm: '0'
    }} className={heading}>
        {text}
      </Heading>
      <div>
        <Button variant="gradient" onClick={() => setIsVisible(true)}>
          Get in touch
        </Button>
      </div>
    </SmallContainer>;
};
const heading = parse({}, "hm6ntpm");
const container = parse({
  display: {
    _: 'flex',
    sm: 'grid'
  },
  justifyContent: 'center',
  alignItems: {
    _: 'center',
    sm: 'flex-end'
  },
  py: '8'
}, "c1j3b7ad");

require("./CbCta.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./CbCta.tsx");